import { jsx, jsxs } from "react/jsx-runtime";
import { lazy, memo, Suspense } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { FinanceDrawerEnum } from "./Finance.types.js";
import styles from "./Finance.module.scss.js";
const CreditCard = lazy(() => import("./creditCard/index.js").then((module) => ({ default: module.CreditCard })));
const CreditDrawer = lazy(() => import("./creditDrawer/index.js").then((module) => ({ default: module.CreditDrawer })));
const TradeInDrawer = lazy(() => import("./tradeInDrawer/index.js").then((module) => ({ default: module.TradeInDrawer })));
const TradeInCard = lazy(() => import("./tradeInCard/index.js").then((module) => ({ default: module.TradeInCard })));
const Finance = memo(function Finance2({
  selectedDrawer,
  vehicleItem,
  creditData,
  isCreditCardShow,
  isTradeInCardShow,
  onDrawerClose,
  onCardButtonClick,
  creditPriceLabel,
  tradeInPriceLabel,
  isHidden
}) {
  const renderDrawer = (drawer) => {
    switch (drawer) {
      case FinanceDrawerEnum.Credit:
        return /* @__PURE__ */ jsx(CreditDrawer, { vehicleItem, onClose: onDrawerClose });
      case FinanceDrawerEnum.TradeIn:
        return /* @__PURE__ */ jsx(TradeInDrawer, { onClose: onDrawerClose });
      default:
        return null;
    }
  };
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: styles.finance, children: /* @__PURE__ */ jsxs(Suspense, { fallback: null, children: [
    /* @__PURE__ */ jsxs(Row, { gutter: [18, "vertical-sky"], children: [
      isCreditCardShow && /* @__PURE__ */ jsx(Col, { xs: 24, sm: 24, md: isTradeInCardShow ? 12 : 24, children: /* @__PURE__ */ jsx(
        CreditCard,
        {
          creditData,
          onClick: () => onCardButtonClick(FinanceDrawerEnum.Credit),
          priceLabel: creditPriceLabel
        }
      ) }),
      isTradeInCardShow && /* @__PURE__ */ jsx(Col, { xs: 24, sm: 24, md: isCreditCardShow ? 12 : 24, children: /* @__PURE__ */ jsx(
        TradeInCard,
        {
          onClick: () => onCardButtonClick(FinanceDrawerEnum.TradeIn),
          priceLabel: tradeInPriceLabel
        }
      ) })
    ] }),
    renderDrawer(selectedDrawer)
  ] }) });
});
export {
  Finance
};
